import store from "@/store"
import { WSSURL } from "@/assets/js/baseURL"
import {
  getToken
} from "@/assets/js/auth.js";
import {
  deepClone
} from "../utils";
var ws = null
const $ws = {
  newsocket: () => {
    if ("WebSocket" in window && !ws) {
      let url = WSSURL
      ws = new WebSocket("wss://" + url)
      // ws = new WebSocket("wss://"handbookv1.chinahc.wang":8787");
      ws.onopen = $ws.WSonopen
      ws.onerror = $ws.WSonerror
      ws.onmessage = $ws.WSonmessage
      ws.onclose = $ws.WSonclose
    }
    // else{
    //   console.log("SOCKET已连接，无需重连")
    // }
  },
  WSonopen: () => {
    $ws.loginsocket()
    // console.log(getToken())
    console.log("SOCKET连接成功")
  },
  WSonerror: () => {
    console.log("SOCKET连接失败")
  },
  WSonmessage: function (e) {
    const that = this
    const a = JSON.parse(e.data)
    switch (a.type) {
      case "ping":
        $ws.sendwebsocket('{"type":"pong"}');
        break;
      // 党员之声
      case "admin_organization_notice":
        showMessage("您收到一条新的消息，请前往首页查看")
        store.commit('setNotice', a.data)
      case "admin_activity_noticeInfo":
        store.commit("GETFEEDBACK", a.data)
        break
      case "admin_activity_signInfo":
        store.commit("GETSIGNINFO", a.data)
        break;
      case "admin_activity_voteInfo":
        store.commit('GETVOTEDATA', a.data);
        break;
      case "admin_activity_chatInfo":
        store.commit('GETMESSLIST', a.data);
        break;
      case "admin_activity_chatInfo_one":
        addmesslist(a.data);
        // store.commit('GETMESSLIST',a.data);
        break;

      default:
        return
    }

  },
  WSonclose: (e) => {
    console.log("SOCKET连接已断开")
  },
  loginsocket: () => {
    let login_data = '{"type":"admin_login","data":"' + getToken() + '"}'
    // console.log(login_data)
    $ws.sendwebsocket(login_data)
  },
  sendwebsocket: (msg) => {
    ws.send(msg)
  },
  closeWebSocket: () => {
    if (ws !== null) {
      ws.close()
      ws = null
    }
  }
}
// 添加单条留言到数组
function addmesslist(datas) {
  store.getters.messagelist.unshift(datas)
  // console.log(store.getters.messagelist)
  // // store.commit("GETMESSLIST", datas);
}

function showMessage(data) {
  // 检测页面上是否已经有了全局通知元素，如果有，则先删除，再显示新的通知
  if ($(".MessageDiv").length > 0) {
    $(".MessageDiv").hide()
  }
  let style = {
    position: "fixed",
    transition: "top 2s",
    "-webkit-transition": "top 2s",
    width: "50%",
    height: "50px",
    "line-height": "50px",
    background: "#f0f9eb",
    color: "#67c23a",
    border: "1px #e1f3d8 solid",
    left: "50%",
    "margin-left": "-25%",
    top: "10px",
    "text-align": "center",
    display: "none"
  }
  let $div = $("<div class='MessageDiv'></div>")
  $div.css(style)
  $div.html(data)
  $("body").append($div)
  $div.show(500)
  setTimeout(() => {
    $div.hide(() => {
      $div.remove()
    })
  }, 2000)


  // console.log(this.$message)
  // if(document.getElementById("MessageDiv")){
  //     document.getElementById("MessageDiv").remove()
  // }
  // let el = document.createElement("div")
  // el.id = "MessageDiv"
  // el.innerHTML = data.remark
  // // el.appendTo("body")
  // document.body.appendChild(el)
}
export {
  $ws,
}



// WEBPACK FOOTER //
// ./src/assets/js/websocket/newsocket.js